import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/nl";
import "dayjs/locale/es";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
import "dayjs/locale/zh";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/th";
import "dayjs/locale/id";
import "dayjs/locale/cs";
import "dayjs/locale/sv";
import "dayjs/locale/tr";
import "dayjs/locale/ms";
import "dayjs/locale/en";
import "dayjs/locale/fr-ca";
import "dayjs/locale/ko";
import "dayjs/locale/zh-tw";
import "dayjs/locale/da";
import "dayjs/locale/fi";
import "dayjs/locale/hu";
import "dayjs/locale/nb";
import "dayjs/locale/sk";
import "dayjs/locale/ro";
import "dayjs/locale/pt-br";
import "dayjs/locale/bg";
import "dayjs/locale/el";
import "dayjs/locale/et";
import "dayjs/locale/ka";
import "dayjs/locale/lt";
import "dayjs/locale/lv";
import "dayjs/locale/ar";


// eslint-disable-next-line complexity
export function setLocale(language: string) {
  switch (language) {
    case "fr":
      dayjs.locale("fr");
      break;
    case "de":
      dayjs.locale("de");
      break;
    case "nl":
      dayjs.locale("nl");
      break;
    case "es":
    case "es-419":
    case "es-ES":
      dayjs.locale("es");
      break;
    case "pl":
      dayjs.locale("pl");
      break;
    case "pt-br":
      dayjs.locale("pt-br");
      break;
    case "zh-cn":
      dayjs.locale("zh-cn");
      break;
    case "it":
      dayjs.locale("it");
      break;
    case "ja":
      dayjs.locale("ja");
      break;
    case "th":
      dayjs.locale("th");
      break;
    case "id":
      dayjs.locale("id");
      break;
    case "cs":
      dayjs.locale("cs");
      break;
    case "sv":
      dayjs.locale("sv");
      break;
    case "tr":
      dayjs.locale("tr");
      break;
    case "ms":
      dayjs.locale("ms");
      break;
    case "fr-ca":
      dayjs.locale("fr-ca");
      break;
    case "ko-kr":
      dayjs.locale("ko");
      break;
    case "zh-tw":
      dayjs.locale("zh-tw");
      break;
    case "da-dk":
      dayjs.locale("da");
      break;
    case "fi-fi":
      dayjs.locale("fi");
      break;
    case "hu-hu":
      dayjs.locale("hu");
      break;
    case "nb-no":
      dayjs.locale("nb");
      break;
    case "sk-sk":
      dayjs.locale("sk");
      break;
    case "pt-pt":
      dayjs.locale("pt");
      break;
    case "ro-ro":
      dayjs.locale("ro");
      break;
    case "bg-bg":
      dayjs.locale("bg");
      break;
    case "el-gr":
      dayjs.locale("el");
      break;
    case "et-ee":
      dayjs.locale("et");
      break;
    case "ka-ge":
      dayjs.locale("ka");
      break;
    case "lt-lt":
      dayjs.locale("lt");
      break;
    case "lv-lv":
      dayjs.locale("lv");
      break;
    case "ar":
      dayjs.locale("ar");
      break;
    default:
      dayjs.locale("en");
  }
}

// Extend dayjs with plugins at app bootstrap level
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default dayjs;